import { SURVEY } from '@constants/terminology';
import { SurveyType } from '@g17eco/types/surveyCommon';
import { DataPeriods, getPeriodOptions } from '@utils/dataPeriods';
import { getMonthNonJSOptions } from '@utils/date';
import { getSurveyTypeOptions } from '@utils/survey';
import { SelectOption } from '@g17eco/types/select';

type Option = Pick<SelectOption<string>, 'label' | 'searchString' | 'value'> & {
  isDisabled?: boolean;
};

export interface Filters<T = SurveyType> {
  surveyType: T[];
  period: DataPeriods[];
  month: string[];
  year: string[];
}

export enum SurveyFilters {
  Month = 'month',
  Year = 'year',
  Period = 'period',
  SurveyType = 'surveyType',
}

export const getInitialSurveyFilters = <T = SurveyType>(
  defaultFilter: Partial<Filters<T>> | undefined
): Filters<T> => ({
  surveyType: [],
  period: [],
  month: [],
  year: [],
  ...defaultFilter,
});

export const getSurveyFilters = ({
  surveyOptions = getSurveyTypeOptions(),
  yearOptions,
}: {
  surveyOptions?: Option[];
  yearOptions: Option[];
}) => ({
  [SurveyFilters.SurveyType]: {
    label: `${SURVEY.CAPITALIZED_SINGULAR} Type`,
    options: surveyOptions,
  },
  [SurveyFilters.Period]: {
    label: 'Period',
    options: getPeriodOptions(),
  },
  [SurveyFilters.Month]: {
    label: 'Month',
    options: getMonthNonJSOptions().map((option) => ({ ...option, value: String(option.value) })),
  },
  [SurveyFilters.Year]: {
    label: 'Year',
    options: yearOptions,
  },
});
